// interface Props {
//   editorPlugins?: any;

//   dynamicVariable?: string | null;
//   fallbackProperties?: string[];

//   activeType?: "element" | "set" | "combo" | "slide";
//   path?: any;
// }

interface Result {
  hasDynamicVariable: boolean;
  hasDynamicVariableBeenParsed: boolean;
  dynamicVariable: string;
  id?: string;
}

export const useDynamicVariable = ({
  variable,
  id,
}: {
  variable?: string | null;
  id: string;
}): Result => {
  let hasBeenParsed = false;
  let hasDynamicVariable = false;
  let dynamicVariable = "";

  if (typeof variable === "string") {
    if (!variable.startsWith("{{")) {
      hasBeenParsed = true;
      hasDynamicVariable = false;
      dynamicVariable = variable;
    } else {
      dynamicVariable = variable;
      hasDynamicVariable = true;
    }
  }
  // useEffect(() => {
  //   if (
  //     !fallbackProperties ||
  //     fallbackProperties.length === 0 ||
  //     !activeType ||
  //     !path
  //   ) {
  //     return;
  //   }

  //   if (value != null && isEditor && hasBeenParsed) {
  //     const changeValue = editorPlugins.changeValue;
  //     fallbackProperties.forEach((property) => {
  //       const changeValueData = {
  //         path: path,
  //         data: {
  //           name: property,
  //           content: value,
  //         },
  //         object: activeType,
  //       };
  //       dispatch(changeValue(changeValueData));
  //     });
  //   }
  // }, [value, isEditor, hasBeenParsed, fallbackProperties]);

  return {
    hasDynamicVariable,
    hasDynamicVariableBeenParsed: hasBeenParsed,
    dynamicVariable,
    id,
  };
};
